import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import Spinner from "./components/spinner/Spinner";
import NewUserForm from './components/users/NewUserForm';
import Dashboard from "./components/navigation/Dashboard";
import { getUserFromDb} from './store/localDb';
import { setUserStateLoaded, getCurrentUserId, getUserStateLoaded, resetAllLoaded, userState, setTestMode, setDemoMode, getStateScope, getAppState, useAppStateSnapshot } from './store/storeValtio';
import { loadDataFromDb } from "helpers/generalHelpers";
import Development from "components/settings/Development";
import LoadUserData from "components/users/LoadUserData";
import HelpModal from "components/help/HelpModal";
import ClearData from "components/settings/ClearData";
import UseAppModal from "components/common/UseAppModal";

export const AppVersionFixed = "0.06"
export default function App() {
  const [currentUserId, setCurrentUserId] = useState();
  console.log('App', window.location.href);
  const appState = useAppStateSnapshot();
  console.log('appState', appState);

  const localCurrentUser = localStorage.getItem("currentUser");
  console.log("local currentUser: ", localCurrentUser, currentUserId);
  
  const location = useLocation();
  const route = location.pathname;
  console.log('route', route)

  useMemo(() => {
      console.log('UE route',location.pathname)
  }, [location])

  const testUsers = [
    'james@percentage.com',
    'charise@percentage.com',
    'jimmy@john.com'
  ];

  useMemo(() => {
    const userId = localStorage.getItem("currentUser");
    console.log("App UE: ", userId);

    async function getUser() {
      console.log('App UE getUser', userId);
      if (userId) {
        let response = await getUserFromDb(userId);
        let result = await response;
        console.log('App UE result:', result);
        if (!result) {
          localStorage.removeItem("currentUser");
          console.log("No user in DB, local user cleared");
          setUserStateLoaded(false);
        } else {
          resetAllLoaded(false);
          setCurrentUserId(getCurrentUserId());

          // set demo/test mode
          const ue = userState.currentUser.email.toLowerCase();
          const scope = getStateScope();
          const tester = testUsers.indexOf(ue) >= 0;
          const apptest = scope ? scope.includes('apptest.') : false;
          console.log('test mode', tester, ue);
          setTestMode(tester || apptest);
          setDemoMode(ue ==='demo@demo.com');
        }
      }
      console.log('App UE getUser done');
    };

    let usl = getUserStateLoaded();
    console.log("App currentUser: ", userId, usl);
    if (userId && !usl) getUser();
    usl = getUserStateLoaded();
    console.log('App UE finished', usl);
  },[])

  // async function gira() {
  //   console.log('gira');
  //   const ira = navigator['getInstalledRelatedApps'];
  //   const relatedApps = await ira.call(navigator);
  //   console.log('getInstalledRelatedApps', relatedApps);
  //   relatedApps.forEach((app) => {
  //     console.log(app.id, app.platform, app.url);
  //   });
  // }
  // gira();

  if (route === '/development') return <Development />;
  if (route === '/loaduserdata') return <LoadUserData />;
  if (route === '/cleardata') return <ClearData />;

  const ua = appState.installed && !appState.standalone;
  //const ua = true;  // for testing
  console.log('ua', ua, appState.installed, appState.standalone);
  if (ua) return (
    <div>
      <UseAppModal open={ua} />
    </div>
  );
  
  if (!localCurrentUser) return (
    <div>
      <HelpModal forWhat={'NewUser'} />
      <NewUserForm />
    </div>
  );
  
  if (!getUserStateLoaded()) {
    console.log('User Not Loaded');
    return (<Spinner />);
  }

  //getUsersFromDb();
  loadDataFromDb(getCurrentUserId());
  
  return (
    <div>
      <Dashboard />
    </div>
  );
}
